import React, { Component } from 'react'
import CollectionGrid from '../collection-grid'
import { selectBestVimeoPoster, httpsify } from '../../lib/vimeo_data_util'

// Get link for grid item
const getHref = (id, slug, match) => {
  const url = match ? match.url : '/'
  const hrefSlug = slug || id
  const hrefPostType = 'collections'
  let href = `${hrefPostType}/${hrefSlug}`
  if (url.substr(-1) !== '/') {
    href = `${url}/${href}`
  }
  return href
}

const getLightboxHref = (match, lightboxIndex) => {
  if (!match) {
    return ''
  }
  const url = match.url
  let href = ''
  if (url.substr(-1) !== '/') {
    href = `${url}/${lightboxIndex}`
  } else {
    href = `${url}${lightboxIndex}`
  }
  return href
}

// Get flattened list of all images sources
// by looping through all slides and media lists
const getAllImages = rows => {
  return rows
    .reduce((prev, curr) => {
      // Media list
      // row.get('slide_media)
      const media = curr.slide.get('slide_media')

      // Flatten for list of all images
      prev = prev.concat(media.reduce((p, c) => {
        p = p.concat(c)
        return p
      }, []))

      return prev
    }, [])
}

export default class CollectionGridList extends Component {
    // Get sized images sources
    getImageSources(images, size) {
      return images.map(media => this.getGridSource(media, size))
    }
  
    // Remove duplicates from image list
    getUniqueImages(images) {
      return images.filter((src, index, list) => (
        list.indexOf(src) === index
      ))
    }
  
    getGridSource(item, size) {
      const mediaType = item.get('media')
      const isVideo = mediaType && mediaType === 'video'
      const videoData = isVideo && item.get('slide_video')
  
      let gridSrc = ''
      if (isVideo && videoData) {
        const poster = selectBestVimeoPoster(videoData.toJS())
        gridSrc = poster && httpsify(poster.link)
      } else {
        gridSrc = item.getIn(['slide_image', 'sizes', size])
      }
      return gridSrc
    }
  
    getGridSources(row) {
      const slide = row.slide
      const media = slide && slide.get('slide_media')
  
      let list = []
      media && media.forEach(item => list.push(this.getGridSource(item, 'thumbnail')))
      return list
    }
  
  render() {
    const { rows, match, pageName, active } = this.props
    const isArtistPage = pageName === 'ARTIST' || pageName === 'HOME'

    if (rows) {
      // Artist page groups grid by collections
      // Collection page shows ALL images in spreads
      let gridItems = []

      if (isArtistPage) {
        gridItems = rows.map(row => ({
          id: row.id,
          sources: this.getGridSources(row),
          linkHref: getHref(row.id, row.slug, match),
          title: row.subtitle,
          active: active
        }))
      } else {
        let allImages = getAllImages(rows)
        allImages = this.getImageSources(allImages, 'thumbnail')
        allImages = this.getUniqueImages(allImages)

        gridItems = allImages.map((src, index) => ({
          id: index,
          sources: [src],
          linkHref: getLightboxHref(match, index + 1),
          title: null
        }))
      }

      return (
        <CollectionGrid
          items={gridItems}
          match={match} />
      )
    } else {
      return null
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/collection-list/collection-grid-list.js